const SearchActionTypes = {
	FETCH_SEARCH_RESULTS_START: 'FETCH_SEARCH_RESULTS_START',
	FETCH_SEARCH_RESULTS_SUCCESS: 'FETCH_SEARCH_RESULTS_SUCCESS',
	FETCH_SEARCH_RESULTS_FAILURE: 'FETCH_SEARCH_RESULTS_FAILURE',
	SET_CURRENT_REGION: 'SET_CURRENT_REGION',
	SET_CURRENT_TOWN: 'SET_CURRENT_TOWN',
};

export default SearchActionTypes;
